import { Obj, Sprite, InputEvents, Metrics, UnresolvedObj, ObjectState, Surface } from "./types";

export const recursivelyUpdateObject = (obj: Obj, fn: (obj: Obj) => void) => {
  fn(obj);
  if (obj.children) {
    obj.children.forEach((child) => {
      recursivelyUpdateObject(child, fn);
    });
  }
}

// Relative
export const moveObject = (obj: Obj, dx: number, dy: number, dz: number = 0) => {
  const fn = (o: Obj) => {
    o.x += dx;
    o.y += dy;
    o.z += dz;
  };
  return recursivelyUpdateObject(obj, fn);
}

export type CreateSpriteArgs = {
  w?: number;
  h?: number;
  fill?: number;
}

export const createSprite = ({ w = 0, h = 0, fill = -1 }: CreateSpriteArgs): Sprite => {
  return {
    w,
    h,
    // TODO explore using Uint8Array
    c: new Array(w * h).fill(fill),
  };
}

export type CreateObjectArgs = {
  id?: string;
  x?: number;
  y?: number;
  z?: number;
  w?: number;
  h?: number;
  sprite?: Sprite;
  children?: (Obj | UnresolvedObj)[];
  step?: (startTime: number, timestamp: number, inputEvents: InputEvents, metrics: Metrics, inFocus: boolean, objectState: ObjectState, surface: Surface, obj: Obj) => void;
  isDraggable?: boolean;
}

// TODO fixme, delete me if possible
export const createObject = (args: CreateObjectArgs): UnresolvedObj => {
  const obj = {
    ...args,
  };

  // TODO handle this in a separate resolution step
  // translate children relative to parent
  // if (obj.children) {
  //   obj.children.forEach((child) => {
  //     moveObject(child, obj.x, obj.y, obj.z);
  //   });
  // }

  return obj;
}

export const makeSpriteZeroesInvisible = (sprite: Sprite): Sprite => {
  const newSprite = { ...sprite };
  newSprite.c = newSprite.c.map((v) => (v === 0 ? -1 : v));
  return newSprite;
}

export const drawLine = (sprite: Sprite, x1: number, y1: number, x2: number, y2: number, value: number) => {
  if (x1 === x2) {
    // Vertical line
    const x = x1;
    const [startY, endY] = y1 < y2 ? [y1, y2] : [y2, y1];
    for (let y = startY; y <= endY; y++) {
      const index = y * sprite.w + x;
      if (index >= 0 && index < sprite.c.length) {
        sprite.c[index] = value;
      }
    }
  } else if (y1 === y2) {
    // Horizontal line
    const y = y1;
    const [startX, endX] = x1 < x2 ? [x1, x2] : [x2, x1];
    for (let x = startX; x <= endX; x++) {
      const index = y * sprite.w + x;
      if (index >= 0 && index < sprite.c.length) {
        sprite.c[index] = value;
      }
    }
  } else {
    throw new Error("Only horizontal and vertical lines are supported.");
  }
}
